import { Component, OnInit } from '@angular/core';
import { NormalUser } from 'src/app/classes/device';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MustMatch } from 'src/app/data-service/must-match.validator';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-add-normal-user',
  templateUrl: './add-normal-user.component.html',
  styleUrls: ['./add-normal-user.component.scss']
})
export class AddNormalUserComponent implements OnInit {
  private ResponseVerifiedAddNormalUser$: Subject<any> = new Subject();
  private ResponseVerifiedUpdateNormalUser$: Subject<any> = new Subject();
  private ResponseVerifiedGetDevice$: Subject<any> = new Subject();
  private ResponseVerifiedGetEpcInfo$: Subject<any> = new Subject();

  pipe = new DatePipe('en-US')
  wmsInfo = new NormalUser();
  addNormalUserForm: FormGroup;
  message: string;
  DeviceList: any;
  isEditing: any;
  userId: any;
  deviceId: any;
  editDateOfBirth: any;
  editUserObject: any = {};
  dataObject: any = [];
  deviceEpcId: any;
  deviceObject: any = {};
  editDeviceId: any;
  role: any;
  roleName: string;
  addenergy_meter:any;
  energy_meter = false;
  marked = false;
  public minDate = new Date();
  public maxDate = new Date();
  graph_inv: any;
  time: any = [{ "id": "14" }, { "id": "13" }, { "id": "12" }, { "id": "11" }, { "id": "10" }, { "id": "9" }, { "id": "8" }, { "id": "7" }, { "id": "6" }, { "id": "5" }, { "id": "4" }, { "id": "3" }, { "id": "2" }, { "id": "1" }];

  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService, private toastr: ToastrService) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }

    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.userId = params.id;
      }
    });
  }
  get f() { return this.addNormalUserForm.controls; }
  ngOnInit() {
    if (this.roleName == 'epc') {
      // this.getDeviceList();
    }
    this.addNormalUserForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.
      login_id: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      email: ['', [ Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      password: ['', [Validators.required,Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      mobile_no: ['', [Validators.pattern('^[0-9]*$'), Validators.minLength(10), Validators.maxLength(10)]],
      sim_no: ['', [Validators.pattern('^[0-9]*$'), Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      instd_capacity: ['', [ Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,3})?$")]],
      num_inverter: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      elec_rate: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      start_dt: ['', Validators.required],
      end_dt: ['', Validators.required],
      solar_panel: ['', [Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      num_solar_panel: ['', [Validators.pattern("^[0-9]*$")]],
      confirmPassword: ['', Validators.required],
      energy_meter: [''],
      graph_interval: [''],
    },{
      validator: MustMatch('password', 'confirmPassword')
  }
    );
    if (this.isEditing == true) {
      this.getInfoByUserId();
    }
  }

  // add normal user
  add_user() {
    if(this.addNormalUserForm.value.energy_meter ==true || this.addNormalUserForm.value.energy_meter=='true'){
      this.addenergy_meter = 1;
    }else if(this.addNormalUserForm.value.energy_meter ==false || this.addNormalUserForm.value.energy_meter=='false'){
      this.addenergy_meter = 0;
    }
    if (this.addNormalUserForm.value.graph_interval == "") {
      this.graph_inv = "15";
    } else { this.graph_inv = this.addNormalUserForm.value.graph_interval; }
    var wmsInfo =
    {
      "login_id": this.addNormalUserForm.controls['login_id'].value,
      "name": this.addNormalUserForm.controls['name'].value,
      "email": this.addNormalUserForm.controls['email'].value,
      "password": this.addNormalUserForm.controls['password'].value,
      "mobile_no": this.addNormalUserForm.controls['mobile_no'].value,
      "address": this.addNormalUserForm.controls['address'].value,
      "sim_no": this.addNormalUserForm.controls['sim_no'].value,
      "instd_capacity": this.addNormalUserForm.controls['instd_capacity'].value,
      "num_inverter": this.addNormalUserForm.controls['num_inverter'].value,
      "elec_rate": this.addNormalUserForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addNormalUserForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addNormalUserForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addNormalUserForm.controls['solar_panel'].value,
      "num_solar_panel": this.addNormalUserForm.controls['num_solar_panel'].value,

      "is_emeter":this.addenergy_meter,
      "graph_interval": this.graph_inv
    }
    this.dashbord.addNormalUser(wmsInfo)
    .pipe(takeUntil(this.ResponseVerifiedAddNormalUser$))
    .subscribe(data => {
      if (data.status === true || data.status === 'true') {
        this.toastr.success(data.message);
        this.router.navigate(['/inject-solar/register-epc-users/normal-users']);
      } else if (!data.status) {
        if (data.message == 'Unauthorised or Login Time-out') {
          this.toastr.info(data.message);
          this.router.navigate(["/login"]);
        } else {
          this.toastr.info(data.message);
        }
      }
    },
      err => {
        return console.log(err);
      })
  }
  //update normal user
  update_user() {
    if(this.addNormalUserForm.value.energy_meter ==true || this.addNormalUserForm.value.energy_meter=='true'){
      this.addenergy_meter = 1;
    }else if(this.addNormalUserForm.value.energy_meter ==false || this.addNormalUserForm.value.energy_meter=='false'){
      this.addenergy_meter = 0;
    }
    var wmsInfo =
    {
      "id": this.userId,
      "login_id": this.addNormalUserForm.controls['login_id'].value,
      "name": this.addNormalUserForm.controls['name'].value,
      "email": this.addNormalUserForm.controls['email'].value,
      "mobile_no": this.addNormalUserForm.controls['mobile_no'].value,
      "address": this.addNormalUserForm.controls['address'].value,
      "sim_no": this.addNormalUserForm.controls['sim_no'].value,
      "instd_capacity": this.addNormalUserForm.controls['instd_capacity'].value,
      "num_inverter": this.addNormalUserForm.controls['num_inverter'].value,
      "elec_rate": this.addNormalUserForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addNormalUserForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addNormalUserForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addNormalUserForm.controls['solar_panel'].value,
      "num_solar_panel": this.addNormalUserForm.controls['num_solar_panel'].value,
      "graph_interval": this.addNormalUserForm.controls['graph_interval'].value,
      "is_emeter":this.addenergy_meter,
    }
    this.dashbord.updateNormalUser(wmsInfo)
    .pipe(takeUntil(this.ResponseVerifiedUpdateNormalUser$))
    .subscribe(data => {
      if (data.status === true || data.status === 'true') {
        this.toastr.success(data.message);
        this.router.navigate(['/inject-solar/register-epc-users/normal-users']);
      }  else if (!data.status) {
        if (data.message == 'Unauthorised or Login Time-out') {
          this.toastr.info(data.message);
          this.router.navigate(["/login"]);

        } else {
          this.toastr.info(data.message);

        }

      }
    },
      err => {
        return console.log(err);
      })
  }
  onReset() {
    this.addNormalUserForm.reset();
  }


  //get device list
  // getDeviceList() {

  //   this.dashbord.getAllUserDevice()
  //   .pipe(takeUntil(this.ResponseVerifiedGetDevice$))
  //   .subscribe(
  //     async data => {
  //       if (data.status) {
  //         this.DeviceList = data.resultObject;

  //       } else if (!data.status) {
  //         if (data.message == 'Unauthorised or Login Time-out') {
  //           this.toastr.info(data.message);
  //           this.router.navigate(["/login"]);

  //         } else {
  //           this.toastr.info(data.message);

  //         }

  //       }
  //     },
  //     err => {
  //       return console.error(err);
  //     }
  //   );
  // }

  onDeviceSelect(value) {
    this.deviceId = Number(value);
  }

// Epc Info By Id
  getInfoByUserId() {
    this.editUserObject = {
      id: this.userId
    };
    this.dashbord.getInfoByUserId(this.editUserObject)
    .pipe(takeUntil(this.ResponseVerifiedGetEpcInfo$))
    .subscribe(
        async data => {
          if (data.status) {
            this.editUserObject = {};
            this.dataObject = data.resultObject;
            var editLogin_id = data.resultObject.login_id;
            var editName = data.resultObject.name;
            var editEmail = data.resultObject.email;
            var editMobileNo = data.resultObject.mobile_no;
            var editAddress = data.resultObject.address;
            var editSimNo = data.resultObject.sim_no;
            var editInstdCapacity =data.resultObject.instd_capacity;
            var editNumInverter = data.resultObject.num_inverter;
            var editElecRate = data.resultObject.elec_rate;
            var editStartDate = data.resultObject.start_dt;
            var editEndDate = data.resultObject.end_dt;
            var editSolarPanel = data.resultObject.solar_panel;
            var editNumSolarPanel = data.resultObject.num_solar_panel;
            var editEnergyMeter = data.resultObject.is_emeter;
            if(editEnergyMeter== 0 ){
              this.marked = false;
              this.toggleVisibility(this.marked);
            }
               else if(editEnergyMeter==1){
                this.marked=true;
                this.toggleVisibility(this.marked);
               }

          this.addNormalUserForm.get('login_id').setValue(editLogin_id);
          this.addNormalUserForm.get('name').setValue(editName);
          this.addNormalUserForm.get('email').setValue(editEmail);
          this.addNormalUserForm.get('mobile_no').setValue(editMobileNo);
          this.addNormalUserForm.get('sim_no').setValue(editSimNo);
          this.addNormalUserForm.get('address').setValue(editAddress);
          this.addNormalUserForm.get('instd_capacity').setValue(editInstdCapacity);
          this.addNormalUserForm.get('num_inverter').setValue(editNumInverter);
          this.addNormalUserForm.get('elec_rate').setValue(editElecRate);
          this.addNormalUserForm.get('start_dt').setValue(editStartDate);
          this.addNormalUserForm.get('end_dt').setValue(editEndDate);
          this.addNormalUserForm.get('solar_panel').setValue(editSolarPanel);
          this.addNormalUserForm.get('num_solar_panel').setValue(editNumSolarPanel);
          this.addNormalUserForm.get('password').setValue("password");
          this.addNormalUserForm.get('confirmPassword').setValue("password");
          this.addNormalUserForm.get('graph_interval').setValue( data.resultObject.graph_interval);

          }else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  toggleVisibility(e){
  if(e==false){
   this.marked= false;
   this.energy_meter= false;
  }else if(e==true){
    this.marked= true;
    this.energy_meter= true;
   }
  }
  ngOnDestroy() {
    this.ResponseVerifiedAddNormalUser$.next();
    this.ResponseVerifiedAddNormalUser$.complete();
    this.ResponseVerifiedUpdateNormalUser$.next();
    this.ResponseVerifiedUpdateNormalUser$.complete();
    this.ResponseVerifiedGetEpcInfo$.next();
    this.ResponseVerifiedGetEpcInfo$.complete();
    this.ResponseVerifiedGetDevice$.next();
    this.ResponseVerifiedGetDevice$.complete();
  }
  changeTime(e) {
  }
}
